// Brand + content data for ASTANA KUCING'S landing page (Bahasa Melayu)

export const BRAND = "ASTANA KUCING'S";
export const WHATSAPP_NUMBER = "601114379853"; // format antarabangsa untuk wa.me
export const TIKTOK_URL = "https://www.tiktok.com/@astanakucing?_r=1&_t=ZS-997JwCs3y9X";
export const FACEBOOK_URL = "https://www.facebook.com/share/195XMQN7eB/";

export const waLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const NAV_LINKS = [
    { label: "Kelebihan", href: "#kelebihan" },
    { label: "Katalog", href: "#katalog" },
    { label: "Penghantaran", href: "#penghantaran" },
    { label: "FAQ", href: "#faq" },
];

export const REASONS = [
    {
        no: "01",
        title: "Kayu Tahan Cuaca",
        body: "Kayu terpilih & besi/aluminium bersalut yang tahan panas terik dan hujan lebat Malaysia — bertahun-tahun tanpa reput.",
        span: "md:col-span-7",
    },
    {
        no: "02",
        title: "Pengudaraan Mesra Kucing",
        body: "Rekaan pengudaraan silang yang selesa, sejuk dan selamat untuk si bulus anda bernafas lega sepanjang hari.",
        span: "md:col-span-5",
    },
    {
        no: "03",
        title: "Rekaan Kustom",
        body: "Ukuran, warna dan susun atur ikut ruang rumah anda. Setiap astana dibina khas mengikut citarasa.",
        span: "md:col-span-5",
    },
    {
        no: "04",
        title: "Penghantaran Seluruh Malaysia",
        body: "Dari Perlis hingga Sabah & Sarawak — kami uruskan pengangkutan selamat terus ke pintu rumah anda.",
        span: "md:col-span-7",
    },
];

const IMG = "https://customer-assets-eiarnc6j.emergentagent.net/job_sangkar-premium/artifacts/";
const AK7 = { model: "AK7", label: "7 × 3 × 6 kaki", price: "RM 1,440" };
const AK6 = { model: "AK6", label: "6 × 3 × 6 kaki", price: "RM 1,390" };

export const PRODUCTS = [
    // Poster rasmi (lengkap dengan model, saiz & ciri)
    { model: "AK3", label: "3.5 × 2.5 × 6 kaki · 1–3 ekor", price: "RM 1,150", poster: true, image: IMG + "jb2d23rz_18193.jpg" },
    { model: "AK6", label: "6 × 3 × 6 kaki · 2–5 ekor", price: "RM 1,390", poster: true, image: IMG + "auucxl4t_18194.jpg" },
    { model: "AK7", label: "7 × 3 × 6 kaki · 2–5 ekor", price: "RM 1,440", poster: true, featured: true, image: IMG + "qdbjr0e2_18195.jpg" },
    { model: "AK9", label: "8 × 4 × 6 kaki · 2–7 ekor", price: "RM 1,990", poster: true, image: IMG + "0zesemit_18196.jpg" },
    { model: "Catio Custom", label: "Reka khas ikut ruang anda", price: "Hubungi untuk harga", poster: true, image: IMG + "krsabynv_18197.jpg" },
    // Custom Premium series (poster)
    { model: "Grand House", label: "9 × 7 × 5 kaki · rumah/breeder/petshop", price: "RM 2,400", poster: true, image: IMG + "v20slhbc_19931.jpg" },
    { model: "6-Room", label: "9 × 6 × 2 kaki · breeder & petshop", price: "RM 2,000", poster: true, image: IMG + "8whnslas_19961.jpg" },
    { model: "Custom Premium", label: "8 × 6 × 4 kaki", price: "RM 1,600", poster: true, image: IMG + "pdkaa8nk_19970.jpg" },
    { model: "Custom Premium", label: "7 × 6 × 3 kaki · Promo (asal RM 1,700)", price: "RM 1,400", poster: true, image: IMG + "okx82ota_19937.jpg" },
    { model: "Twin Cage", label: "5 × 3 × 3 kaki · 2 unit RM 1,600", price: "RM 900 seunit", poster: true, image: IMG + "r6jag46b_19958.jpg" },
    { model: "Home Classic", label: "6 × 4 × 2.5 kaki · jimat ruang", price: "RM 1,100", poster: true, image: IMG + "oqurvv1c_19974.jpg" },
    { model: "Loft Single", label: "6 × 5 × 3 kaki · 1 bilik luas", price: "RM 1,000", poster: true, image: IMG + "bdhzqbys_19963.jpg" },
    { model: "Custom Premium", label: "6 × 6 × 6 kaki", price: "RM 1,400", poster: true, image: IMG + "c3dsi1wo_19968.jpg" },
    { model: "Custom Premium", label: "8 × 7 × 3 kaki · outdoor/indoor", price: "RM 1,700", poster: true, image: IMG + "cydzj6yf_19965.jpg" },
    // Foto produk sebenar
    { ...AK7, image: IMG + "btua4yj2_6865.jpg" },
    { ...AK7, image: IMG + "mqrwtr06_6868.jpg" },
    { ...AK6, image: IMG + "fzdr8uem_6869.jpg" },
    { ...AK7, image: IMG + "wyhoro90_6871.jpg" },
    { ...AK7, image: IMG + "wompncnd_6872.jpg" },
    { ...AK6, image: IMG + "h1b01ksj_6859.jpg" },
    { ...AK6, image: IMG + "837ggq54_6860.jpg" },
    { ...AK7, image: IMG + "shnh3wrt_6861.jpg" },
    { ...AK7, image: IMG + "lc8i4qlu_6862.jpg" },
    { ...AK7, image: IMG + "04ouxywk_6864.jpg" },
    // Siri AB
    { model: "AB1", label: "6 × 3 × 6 kaki", price: "RM 1,400", image: IMG + "lgn44zer_19994.jpg" },
    { model: "AB2", label: "6 × 3 × 6 kaki", price: "RM 1,350", image: IMG + "wpc8l3m1_19987.jpg" },
    { model: "AB3", label: "2.5 × 2.5 × 6 kaki", price: "RM 1,000", image: IMG + "hl7xhwjj_13616.jpg" },
    { model: "AB4", label: "5 × 3 × 6 kaki", price: "RM 1,200", image: IMG + "06xj4qox_12356.jpg" },
    { model: "AB5", label: "6 × 3 × 6 kaki", price: "RM 1,400", image: IMG + "suxwb1md_19949.jpg" },
];

export const TESTIMONIALS = [
    {
        quote: "Kualiti kayu memang mantap, kemasan halus dan kucing saya nampak lebih tenang. Berbaloi setiap sen!",
        name: "Aina R.",
        loc: "Shah Alam, Selangor",
        image: "https://images.unsplash.com/photo-1774279922369-755504a8b495",
    },
    {
        quote: "Order catio kustom ikut ukuran laman. Team datang buat lawatan, siap ikut janji. Sangat profesional.",
        name: "Firdaus H.",
        loc: "Kajang, Selangor",
        image: "https://images.pexels.com/photos/19370105/pexels-photo-19370105.jpeg",
    },
    {
        quote: "Penghantaran sampai Kuantan dengan selamat, semua elok. Terima kasih ASTANA KUCING'S!",
        name: "Nurul I.",
        loc: "Kuantan, Pahang",
        image: "https://images.pexels.com/photos/6897076/pexels-photo-6897076.jpeg",
    },
];

export const FAQS = [
    {
        q: "Bagaimana cara pemasangan sangkar?",
        a: "Sangkar standard dihantar hampir siap pasang — hanya perlu kunci beberapa bahagian dengan panduan bergambar yang kami sertakan. Untuk catio kustom, pasukan kami akan datang memasang di tapak anda.",
    },
    {
        q: "Sejauh mana ketahanan bahan?",
        a: "Kami guna kayu terpilih bersalut anti-cuaca serta besi/aluminium tahan karat. Direka khas untuk iklim panas & lembap Malaysia supaya tahan bertahun-tahun.",
    },
    {
        q: "Berapa lama tempoh penghantaran?",
        a: "Produk sedia stok: 3–7 hari bekerja. Rekaan kustom: 2–4 minggu bergantung pada saiz & reka bentuk. Kami akan maklumkan jangkaan tarikh semasa tempahan.",
    },
    {
        q: "Ada khidmat custom ukuran?",
        a: "Ada! Hantar ukuran ruang & idea anda melalui WhatsApp. Kami bantu reka, beri anggaran harga dan bina astana khas mengikut citarasa serta ruang rumah anda.",
    },
];
